import Qs from 'qs'

/**
 * 处理url上的vt参数
 * 场景：合伙人版爆款专区进入商品详情，商品详情跳回爆款专区，需要将vt带回去
 */
export const handleLocationUrl = () => {
    const pageQuery = Qs.parse(window.location.search, { ignoreQueryPrefix: true })
    const vt = pageQuery?.vt

    return vt
        ? {
              vt,
          }
        : {}
}
